module.exports = __webpack_public_path__ + "static/impeach-b23278636d580edd890bf953b2f94b61.jpg";